import faradayApi from "../../../api/faradayApi";

export const sendNotifications = async (usersIds, message) => {
  const endpoint = "/notifications";

  const data = {
    usersIds,
    message,
  };

  const response = await faradayApi.post(endpoint, data);

  return response.data;
};
